import { a as t } from "../../../chunk-OA3DH5LS-40f95340.js";
const a = t("SmartAnimation").parts(
  "animation",
  "content",
  "root"
), r = {
  parts: a.keys,
  baseStyle: {
    animation: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "calc(100% + var(--border-width) * 2)",
      height: "calc(100% + var(--border-width) * 2)",
      transform: "translate(-1px, -1px)",
      pointerEvents: "none"
    },
    root: {
      "--border-width": "1px",
      position: "relative",
      height: "auto",
      display: "flex"
    },
    content: {
      isolation: "isolate",
      position: "relative",
      width: "100%",
      height: "100%",
      borderRadius: "100px",
      borderWidth: "var(--border-width)",
      borderColor: "transparent",
      "&[data-loading]": {
        pointerEvents: "none",
        "&::before": {
          content: "''",
          position: "absolute",
          transform: "translateX(var(--border-width) * -1)",
          inset: "calc(var(--border-width) * -1)",
          animation: "spin 3s linear infinite",
          animationPlayState: "running",
          borderRadius: "inherit",
          border: "inherit",
          backgroundImage: "conic-gradient(from var(--angle), transparent 80%, var(--chakra-colors-secondary-500) 90%, transparent 100%)",
          backgroundOrigin: "border-box",
          zIndex: 1,
          maskImage: "linear-gradient(black, black), linear-gradient(black, black)",
          maskClip: "content-box, border-box",
          maskComposite: "exclude",
          "@keyframes spin": {
            to: { "--angle": "1turn" }
          }
        }
      }
    }
  },
  sizes: {
    auto: {
      root: {
        width: "auto"
      },
      content: {
        width: "auto"
      }
    },
    fullwidth: {
      root: {
        width: "100%"
      },
      content: {
        width: "100%"
      }
    }
  },
  defaultProps: {
    size: "auto"
  }
};
export {
  r as SmartAnimation,
  a as SmartAnimationAnatomy
};
//# sourceMappingURL=SmartAnimation.es.js.map
